import PingApi from "./apis/PingApi";
import ProfilApi from "./apis/ProfilApi";
import SsoApi from "./apis/SsoApi";
import ConcoursApi from "./apis/ConcoursApi";
import ChallengeApi from "./apis/ChallengeApi";
import MediaApi from "./apis/MediaApi";
import CollaboratorApi from "./apis/CollaboratorApi";
import ParcourirApi from "./apis/ParcourirApi";
import CommercialApi from "./apis/CommercialApi";
import NotificationApi from "./apis/NotificationApi";
import ProApi from "@/services/apis/ProApi";
import ExportApi from "@/services/apis/ExportApi";
import ParametrageApi from "@/services/apis/ParametrageApi";
import ExportRetrievalApi from "@/services/apis/ExportRetrievalApi";

//Permet d'acceder à toutes les APIs
export default {

    //Permet d'effectuer un ping sur l'api
    getPingApi() {
        return PingApi;
    },

    //Permet d'effectuer les opérations concernant le profil de l'utilisateur
    getProfilApi(){
        return ProfilApi;
    },

    getSsoApi(){
        return SsoApi;
    },

    //Permet d'effectuer les actions concernant les concours
    getConcoursApi(){
        return ConcoursApi;
    },

    //Permet d'effectuer les actions concernant les challenges
    getChallengeApi(){
      return ChallengeApi;
    },

    //Permet d'effectuer les actions concernant les challenges
    getCollaboratorApi(){
      return CollaboratorApi;
    },

    //Permet d'effectuer les actions concernant les medias
    getMediaApi(){
        return MediaApi;
    },

    getParcourirApi(){
        return ParcourirApi;
    },

    getCommercialApi(){
        return CommercialApi;
    },

    getNotificationApi(){
        return NotificationApi;
    },

    getProApi(){
        return ProApi;
    },

    getExportApi() {
      return ExportApi;
    },

    getExportRetrievalApi() {
        return ExportRetrievalApi;
    },

    getParametrageApi() {
        return ParametrageApi;
    }
}
